import styled from 'styled-components';

const Frame = styled.div`
	--background: ${props => 'var(--bs-'+props.background+')'};
	--buttonsBackground: ${props => 'var(--bs-'+props.buttonsBackground+')'};
	--color: ${props => 'var(--bs-'+props.color+')'};
	--radius: 3px;
	--padding: 10px;
`;

// CGN (30/10/2026): El título se muestra como título de sección: en mayúsculas, negrita, 15 px, alineado con las etiquetas de los campos
// y con una línea inferior a todo el ancho (antes 12 px, sin negrita y desplazado 10 px a la derecha por el relleno de la antigua pestaña).
const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	border-bottom: 1px solid var(--bs-gray-300);
	margin-bottom: 12px;
`;

const Label = styled.div`
	display: inline-block;
	// background: var(--background);
	padding: 0 0 4px 0;
	border-top-left-radius: var(--radius);
	border-top-right-radius: var(--radius);
	color: var(--color);
	font-size: 15px;
	font-weight: bold;
	text-transform: uppercase;
`;

const Buttons = styled.div`
	display: inline-block;
	background: var(--buttonsBackground);
	padding: 1px var(--padding);
	border-top-left-radius: var(--radius);
	border-top-right-radius: var(--radius);
	color: var(--color);
	font-size: 12px;
`;

const Content = styled.div`
	// padding: var(--padding);
	// border: 1px solid var(--background);
	border-radius: var(--radius);
	border-top-left-radius: 0px;
	border-top-right-radius: 0px;
`;

export default function LabeledFrame(props) {
	
	return (
		<Frame 
			className={props.className ?? ''} 
			style={props.style ?? {}} 
			background={props.background ?? 'gray-400'} 
			color={props.color ?? 'dark'}
			buttonsBackground={props.buttonsBackground ?? 'gray-300'} 
		>
			<Header>
				<Label>{props.label}</Label>
				{props.buttons && <Buttons>{props.buttons}</Buttons>}
			</Header>
			<Content>
				{props.children}
			</Content>
		</Frame>
	);
}